/**
* @file 运营中心-乘客反馈
* */ 
<template>
  <div id="feedback" class="feedback">
    <el-dialog :visible.sync="visible" @close="replyContent = null" width="500px" title="乘客反馈">
      <div class="feedback-cont">
        <div>
          <span>时间</span>
          <span>{{ selectFeedback.created | filterTime("YYYY/MM/DD HH:mm") }}</span>
        </div>

        <div>
          <span>类型</span>
          <span>{{ selectFeedback.type==2?'订单问题':'其他问题' }}</span>
        </div>

        <template v-if="selectFeedback.type==2">
          <div>
            <span>订单号</span>
            <span>{{ selectFeedback.orderJson.orderNo }}</span>
          </div>
          <div>
            <span>车辆号牌</span>
            <span v-if="selectFeedback.orderJson.licenseNo" :style="getPlateStyle(selectFeedback.orderJson.licenseNo)">{{ formatPlateNumber(selectFeedback.orderJson.licenseNo) }}</span>
            <span v-else>-</span>
          </div>
          <div>
            <span>值班司机</span>
            <span>{{ selectFeedback.orderJson.driverName }}</span>
          </div>
        </template>

        <div>
          <span>机构名称</span>
          <span>{{ selectFeedback.organizationName }}</span>
        </div>

        <div>
          <span>内容</span>
        </div>
        <div class="feedback-cont-text">
          {{ selectFeedback.content }}
        </div>

        <div class="feedback-cont-images" v-if="selectFeedback.feedBackImg">
          <el-image v-for="(imgPath,index) in selectFeedback.feedBackImg.split(',')" :key="index" :src="imgPath" :preview-src-list="selectFeedback.feedBackImg.split(',')" />
        </div>

        <div>
          <span>平台回复</span>
        </div>

        <template v-if="status == 1">
          <el-input type="textarea" placeholder="请输入要回复乘客的内容，支持1-100位字符" v-model="replyContent" maxlength="100"></el-input>

          <div class="feedback-cont-images">
            <div class="feedback-cont-images-item" v-for="(imgPath,index) in replyImg" :key="index">
              <el-image :src="imgPath" :preview-src-list="replyImg" />
              <img src="../../assets/img/feed-clear.png" @click="replyImg.splice(index,1)" />
            </div>

            <div class="feedback-cont-images-item--add" v-if="replyImg.length<3" @click="$refs.inputFile.click()">
              <img src="../../assets/img/feed-camera.jpg" />
              <div>添加照片</div>
            </div>

            <input ref="inputFile" id="inputFile" type="file" onblur="value=''" @change="inputFileChange" accept="image/*" />
          </div>
        </template>

        <template v-else>
          <div class="feedback-cont-text">
            {{ selectFeedback.replyContent }}
          </div>
          <div class="feedback-cont-images" v-if="selectFeedback.replyImg">
            <el-image v-for="(imgPath,index) in selectFeedback.replyImg.split(',')" :key="index" :src="imgPath" :preview-src-list="selectFeedback.replyImg.split(',')" />
          </div>

          <div>
            <span>回复时间</span>
            <span>{{ selectFeedback.replyTime | filterTime("YYYY/MM/DD HH:mm") }}</span>
          </div>
          <div>
            <span>回复人</span>
            <span>{{ selectFeedback.replyAdminName }}</span>
          </div>
        </template>

      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false" v-if="status == 1">取 消</el-button>
        <el-button type="primary" :loading="loadingSave" @click="save" v-if="status == 1">提交回复</el-button>
        <el-button @click="visible = false" v-if="status == 2">关 闭</el-button>
      </div>
    </el-dialog>

    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" :has-organization="true" >
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="100px">
          <div slot-scope="{ row }" class="custom-action">
            <el-tooltip v-if="row.replyTime" content="查看" placement="top">
              <i class="el-icon-view" @click="look(row)"></i>
            </el-tooltip>
            <el-tooltip v-else content="回复" placement="top">
              <img src="../../assets/img/huifu.png" @click="reply(row)" style="width: 20px; cursor: pointer" />
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime
        }}</template>
        <template v-else-if="item.prop === 'replyTime'">{{
          row.replyTime | filterTime
        }}</template>
        <template v-else><span class="ellipsis">{{ row[item.prop] ? row[item.prop] : "-" }}</span></template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "feedback",
  data() {
    return {
      // 配置项
      customOptions: {
        
        // 请求的列表url
        url: "/api/v1/manage/feedBack",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "replyStatus",
            name: "回复状态",
            value: "",
            option: [
              { label: "全部", value: null },
              { label: "已回复", value: 1 },
              { label: "未回复", value: 2 },
            ],
          },
          {
            type: "input",
            field: "customerPhone",
            name: "手机号",
            value: "",
          },
        ],
      },
      columns: [
        { prop: "customerPhone", label: "注册手机号" },
        { prop: "content", label: "客诉内容", minWidth: 300 },
        { prop: "created", label: "反馈时间" ,minWidth: 150},
        { prop: "replyContent", label: "平台回复", minWidth: 300 },
        { prop: "replyTime", label: "回复时间"  ,minWidth: 150},
        { prop: "replyAdminName", label: "回复人" },
      ],
      uploadUrl: "http://up-z1.qiniu.com",
      visible: false,
      status: 1,
      replyContent: null,
      replyImg: [],
      loadingSave: false,
      selectFeedback: {},
    };
  },
  created() {
    if (window.location.protocol === "http:") {
      this.uploadUrl = "http://up-z1.qiniu.com";
    } else if (window.location.protocol === "https:") {
      this.uploadUrl = "https://upload-z1.qbox.me";
    }
  },
  methods: {
    reply(row) {
      this.selectFeedback = { ...row };
      this.selectFeedback.orderJson = row.orderJson ? JSON.parse(row.orderJson) : null;
      this.visible = true;
      this.status = 1;
    },
    look(row) {
      this.selectFeedback = { ...row };
      this.selectFeedback.orderJson = row.orderJson ? JSON.parse(row.orderJson) : null;
      this.visible = true;
      this.status = 2;
    },
    /* 预览图片 */
    // previewImage(path){

    // },

    /* 选择图片 */
    async inputFileChange(event) {
      if (event.target.files.length == 1) {

        let file = event.target.files[0];
        let qiniuToken = await this.getQiniuTokenFn();
        let formData = new FormData();
        formData.append("token", qiniuToken);
        formData.append("file", file);

        let data = await this.$axios.post(this.uploadUrl, formData);

        event.target.value = '';  // 清空input文件 使选择相同图片可触发inputFileChange


        if (data && data.hash) {
          const externalLinks = require('@/assets/json/externalLinks').default
          this.replyImg.push(`${externalLinks.resources.qiniuDomain}${data.hash}`);
        } else {
          this.$message.warning("上传失败，请稍后再试");
        }
      }
    },
    async save() {
      if (!this.replyContent || !this.replyContent.trim()) {
        this.$message.warning("反馈内容不能为空");
        return;
      }
      let url = "/api/v1/manage/feedBack";
      let params = {
        id: this.selectFeedback.id,
        replyContent: this.replyContent,
        replyImg: this.replyImg.join(','),
      };
      this.loadingSave = true;
      let res = await this.$axios.post(url, params);
      if (res && res.code === 1) {
        this.replyContent = '';
        this.replyImg = [];
        this.$refs.customTable.listFn();
      }
      this.visible = false;
      this.loadingSave = false;
    },
  },
};
</script>

<style lang="less">
.feedback {
  &-cont {
    & > div {
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      span:nth-child(1) {
        color: #909399;
        font-size: 13px;
      }
      
      span:nth-child(2) {
        color: #303133;
        font-size: 13px;
      }
    }

    &-text {
      background: #f5f7fa;
      padding: 12px 16px;
      border-radius: 8px;
      color: #606266;
      font-size: 13px;
      line-height: 1.6;
      margin-bottom: 16px !important;
    }

    &-images {
      margin: 16px 0 !important;
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 16px;
      
      & .el-image__inner {
        width: 100%;
        height: 120px;
        border-radius: 8px;
        object-fit: cover;
        cursor: pointer;
      }

      &-item {
        height: 100%;
        position: relative;
        display: flex;
        flex-flow: column;
        justify-content: center;
        
        img:nth-child(1) {
          width: 100%;
          border-radius: 8px;
        }
        
        img:nth-child(2) {
          width: 20px;
          height: 20px;
          cursor: pointer;
          position: absolute;
          right: -8px;
          top: -8px;
          transition: transform 0.2s;
          
          &:hover {
            transform: scale(1.1);
          }
        }
      }

      &-item--add {
        height: 120px;
        border-radius: 8px;
        border: 1px dashed #c0c4cc;
        cursor: pointer;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        background: #fafbfc;
        transition: all 0.2s;
        
        &:hover {
          border-color: #2B77FF;
          background: #f0f7ff;
        }
        
        img {
          width: 40px;
          margin-bottom: 8px;
          opacity: 0.6;
        }
        
        div {
          font-size: 12px;
          color: #909399;
        }
      }

      input {
        position: absolute;
        width: 0;
        opacity: 0;
      }
    }
  }

  .el-textarea__inner {
    height: 100px;
    overflow: hidden;
    resize: none;
    border-radius: 8px;
  }
  
  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid #ebeef5;
    
    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }
  
  .el-dialog__body {
    padding: 20px 24px;
  }
  
  .dialog-footer {
    text-align: center;
    
    .el-button {
      min-width: 120px;
      border-radius: 6px;
    }
  }

  // 操作按钮样式
  .custom-action {
    display: flex;
    align-items: center;
    justify-content: center;
    
    .el-icon-view {
      font-size: 18px;
      color: #2B77FF;
      cursor: pointer;
      transition: all 0.2s;
      
      &:hover {
        color: #1a5fd9;
      }
    }
    
    img {
      transition: all 0.2s;
      
      &:hover {
        transform: scale(1.1);
      }
    }
  }

}

// 省略号样式 - Element UI 表格单元格内的省略号
#feedback .el-table .cell .ellipsis {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.6;
  font-size: 13px;
  color: #606266;
  display: block;
}
</style>
